module.exports = __webpack_public_path__ + "img/die-furche.32f2eac1.svg";